// About.tsx
import React from 'react';

const About: React.FC = () => {
  return <h1>About Page</h1>;
};

export default About;
